import styled from 'styled-components';
import { CalendarContainer } from '../Calendar/styles';
import { PseudoCalendarContainer } from '../PseudoCalendar/styles';

export const CalendarWithWavesContainer = styled(CalendarContainer)`
    .time-wrapper {
        display: flex;
        width: 100%;
        gap: 0.5rem;
    }

    .category-wrapper {
        display: flex;
        width: 100%;
        gap: 0.75rem;
    }
`;

export const CustomDropdown = styled(PseudoCalendarContainer)`
    justify-content: space-between;
    flex: 1 0 0;
    svg {
        width: 1.25rem;
        height: 1.25rem;
    }
    padding: 0;

    > button {
        padding: 0;
        border: none;
        pointer-events: all;
        height: 100%;
        align-items: center;
        min-width: 100% !important;
        padding: 0.75rem 1rem;

        color: var(--Neutral-950, #09090b);
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5rem;
    }
`;
